/*
 * 81 数理完整释义（新版）
 * 数据来源：/Users/xiaodongliu/Downloads/轩书房/1-输入/3-专题笔记/国学/姓名学八十一数理/81数理详解.md
 * 由 scripts/sync-nameology-data.mjs 自动生成，请勿手改。
 */

export interface Numerology81Meta {
  symbol: string;
  title: string;
  subtitle: string;
  genderLuck: string;
  chartLuck: string;
}

export const NUMEROLOGY_81_FULL_TEXT: Record<number, string> = {
  "1": "◎1（宇宙起源）：天地宇宙开泰的太极数。\n\n男女吉凶：男女皆大吉\n\n基业：聪明、多学、成功、富贵、名誉、幸福、财帛、进田。\n\n家庭：竹木成林，父母有荫，家庭圆满，子女多孝。\n\n健康：健全，可望长寿，天、人、地三格相克不善者不遇。\n\n含义：此为万事万物的基本数，为最大吉祥的表示，属于分外大成功，健康、富贵、名誉、幸福，可以享福终世。因其过好，常人难承；当数与八字相合者，则可以纵横一世，运势特佳，凡事顺利。",
  "2": "▲2（一身孤节）：混沌未定的分离破灭数。\n\n男女吉凶：男女皆大凶\n\n基业：劫财、破灭、灾危、破家、红艳、变迁、美貌。\n\n家庭：亲情疏远，夫妻应相互理解，则免别离之苦。\n\n健康：凶弱、短亦有之，易患皮肤病、外伤、夭折。\n\n含义：混沌未定数，为最大凶恶的暗示，无独立之气力，进退失自由，其内外生波澜，因而痛苦不安。摇动、病患、遭难，甚至残废。如伴有其他好数者不致夭折。其人辛苦一生，志望难达，破灭无常。\n如有其他吉数者相伴，则不致太凶，可获平安，白手生财。无亲朋好友助力，若与人合伙经营可获利。要注意与人不合，易得罪人。",
  "3": "◎3（吉祥）：进取如意的增进繁荣数。\n\n男女吉凶：男女皆大吉\n\n基业：术、技艺、祖业、丰盛、自立、建业、官禄。\n\n家庭：家内施惠，可得贤妻，六亲和睦，须戒自私。\n\n健康：松柏林立，健康良好，可望长寿。\n\n含义：阴阳抱合，万物确定形成之象，有吉祥、成功发达之兆。智达明敏，艺精工巧，有首领之资，自然之福。名利双全，能成人事业，荣进有望，福祉无穷。若在变格时，其后天努力奋斗时有贵人提携，受部属拥护，自然功成名就。\n女性人格与变格有此数者，温和贤淑，益子孙之运。",
  "4": "▲4（凶变）：身遭凶变的万事休止数。\n\n男女吉凶：男女皆大凶\n\n基业：美貌、香艳、破家、灾危、劫财、损家业。\n\n家庭：六亲缘薄，兄弟如同画饼，热心相助者少，应看开一些。\n\n健康：衰弱、外伤、皮肤病、夭折病死、发狂病。\n\n含义：属破坏的凶变数，不足不全的灭亡之数。进退不自由，独立乏能力。大多辛苦困难，或者与其他凶运配合而致发狂病死、夭折；或者放浪、破灭、逆难终成废人。但孝子、节妇、怪杰等，也有出自此数者。\n在人格与变格时，易发无名火、带血光、刑伤，早婚不顺，不易与人合作，应独自经营较佳。",
  "5": "◎5（种竹成林）：富贵长寿的福禄集合数。\n\n男女吉凶：男女皆大吉\n\n基业：学者、祖业、文昌、福星、官星、财钱。\n\n家庭：上下和睦，相互合作，可望圆满，子女多荫。\n\n健康：福禄如海，寿比南山，可望健康。\n\n含义：阴阳交感，和合、完璧之象，隐藏大成功运。精神敏锐，身体健全，福禄长寿，富贵繁荣，无所不至。或为中兴之祖，或在他乡成家，或复兴绝家。即或不如此，也会博得功名荣誉，圆满无碍，福祉祯祥无比。\n在人格与变格时，忠厚老实，脚踏实地，口才不佳，重承诺；财运特佳，金钱有余，离祖发达。女性有荣夫、益子之运。",
  "6": "◎6（安稳）：安稳吉庆的吉人天相数。\n\n男女吉凶：男女皆大吉\n\n基业：豪杰、官禄、财钱、将星、学者。\n\n家庭：得祖上荫护，家门昌盛，子孙兴旺。\n\n健康：逢凶化吉，遇一次生险，可得长寿。\n\n含义：天德地祥具备，福庆甚广，家势盛大、万宝朝宗之运，然满极必损，盈极必亏。若其他运格配合得不周，恐或如流水而下，成为所谓乐极生悲之象。此数理具有天赋之美，安稳吉庆终生。\n在人格与变格时，忠厚老实，脚踏实地，个性正直、带刚性，名声信誉良好，发展步步高升。",
  "7": "○7（精悍）：刚毅果断，勇往直前的进取数。\n\n男女吉凶：男女皆吉\n\n基业：独立、官禄、进取、技术、刚硬。\n\n家庭：缺乏同心力，内外不和，善涵养修身者适得家庭圆满。\n\n健康：日月光明，心身健保，可望长寿。\n\n含义：独立、单行、极感之象，过刚而缺乏同化力之意。如果顽刚弄权，易酿成内外不和，幸而天赋的精力充沛，具有调节事物的才能，能够粉碎硬敌，排除万难。若能涵养雅量，扩大气度，自然幸福上进。\n女性有此数者，难免有男性之情性，切要注意温和才会吉利而无过失。在人格与变格时，口才佳，个性刚硬，事业心强，适合有挑战性工作，辛苦得财，有耐力。略感孤独，应多交友。修身养性者成大功。",
  "8": "○8（坚刚）：志刚意坚的勤勉发展数。\n\n男女吉凶：男女皆吉\n\n基业：艺能、美术、学者、官禄、天官、师表、蓄产。\n\n家庭：兴家成为达人贤者，家境先难后易。\n\n健康：高山立松，完健自在，可望长寿。\n\n含义：意志如铁石，富于进取气概。排除万难，目的、名利两得，忍耐、克己，逐成大功。但其他运配合不善者，可能有遭难的厄运。\n在人格与变格时，个性较强，做事稳重，口才极好，勤勉上进，有耐力，自强不息，必有一番大作为。",
  "9": "△9（破舟进海）：吉尽凶始，穷乏困苦数。\n\n男女吉凶：男女皆凶\n\n基业：官禄、图印、太极、怪杰、富翁、突破。\n\n家庭：亲情不睦，口说长短者多，力持贤明者平安。\n\n健康：女性成风流或与夫别离病弱，男女皆晚婚。行事多积德，可免短命。\n\n含义：利去劫空，陷落穷迫、逆运、短命，凄惨悲痛，或者幼小离亲而困苦，或者病弱、不遇、遭难、废疾、贫困、灾难、孤独，甚至刑罚。有不测遇凶祸，人格有此数者则为大凶，即或自身得免灾害，也难免配偶丧失，有缺子之叹。\n实为人生最大厄运，但有例外的怪杰、富豪能出此数者。在人格与变格时，聪明灵巧，财来财去，钱不留身，与异性有感情上之纠纷困扰，一生常遇逆境之折磨，短寿、喜好投机之象。",
  "10": "△10（零暗）：万事终局充满损耗数。\n\n男女吉凶：男女皆凶\n\n基业：天福、文昌、散财、官禄、破危、夭寿。\n\n家庭：家内总是冷眼旁观者多，伤害妻子，破镜难圆，凡事百忍者尚可平安。\n\n健康：杀伤、刑罚、病弱、灾危，女易风流，心性变态。\n\n含义：其凶恶更甚于九数，为物事告终之运。有如黑暗的境地，空虚无物，人格有此数者，多非业短命。如同日没，四顾茫茫，神哭鬼嚎、振凶之象，行万象乏气力，常陷于不如意，凡要求功，因多障碍渐自失败，遂致破家亡户；\n或者贫困逆难叠至，无眷属之缘，或者自幼失亲，或者病弱、遭难，或者有不测之灾祸；或者犯官府等，难免非业非运。天、人、地三格相克配合不得其宜者，大都中年前后编进黄泉之籍。然万人中有一二例外，可绝处逢生。\n在人格与变格时，性直，口才不好，易得罪人；事业多波折，厄运特强，并容易累及家人；婚姻易出问题，有浪费金钱之倾向；品行不端，会因犯罪受罚。有喜好投机之象。",
  "11": "◎11（旱苗逢雨）：挽回家运的春阳成育数。\n\n男女吉凶：男女皆大吉\n\n基业：财星、天佑、暗禄、文昌、技艺、田宅。\n\n家庭：养蜂结蜜，事事和顺，处处温和。\n\n健康：河川永在，可望健康长寿。\n\n含义：阴阳复新，享天赋幸运，万事顺利，有得富贵繁荣、再兴家的暗示。能挽回家运平静、和顺的最大吉数。在人格与变格时，心地善良，口才好，人缘特佳，易得人助，给人留有好印象。能力佳，运势好，凡事顺利。",
  "12": "△12（掘井无泉）：意志脆弱的家庭寂寞数。\n\n男女吉凶：男女皆凶\n\n基业：凶星、破厄、劫财、暗禄。\n\n家庭：亲情如秋水，骨肉似寒炭，施恩招怨恨，宜提高气节。\n\n健康：枯木待春，小心神经衰弱、胃癌之疾、外伤、皮肤病。天、人、地三格不克者可安全。\n\n含义：有无理伸张之象，不顾薄弱之力，企图做无能力做的事，多失败。遇事易生不足之心。家庭缘薄、孤独、遇难、逆境、病弱、不如意、困难等，又可因其他运配合而导致意外的失败，甚至有不能完寿的悲运。\n在人格与变格时，自私心重，婚姻不美满；与人合作比自己经营好，喜好投机之象，不能脚踏实地做事，爱面子。",
  "13": "◎13（春日牡丹）：智能超群的成功数。\n\n男女吉凶：男女皆大吉\n\n基业：大官、文昌、技艺、进财、学士、田产、财库。\n\n家庭：祖宗余荫，子孙孝顺，可望团圆。\n\n健康：可望健全长寿，天格五行不和者不遇。\n\n含义：富学艺才能，有智谋奇略，忍柔当事，任何难事，皆巧于措置以奏大功。为得享福贵荣华的好诱导，充满智慧是其特点。最怕流于邪，则自作聪明，未必能有作为。女性有此数者，助夫兴家，子孙繁荣。\n在人格时，性急误事，男命勇敢果断，女命则美貌如仙，均怕聪明反被聪明误，入邪途，有风流好淫之倾向。若自制力不够，往往有异性的困扰发生；在变格时，聪明有智略，人缘特佳，易得人助，给人留有好印象。",
  "14": "△14（破兆）：沦落天涯的失意烦闷数。\n\n男女吉凶：男女皆凶\n\n基业：暗禄、美貌、艺术、流浪、红舞、劫财。\n\n家庭：骨肉疏远，离祖迁居。自家兄弟全无分，外处交友却有缘。\n\n健康：男女均属好貌、皮肤病、感冒、风邪，天格五行相合则有健康。\n\n含义：多破兆，家属缘薄。丧亲、丧子、兄弟姐妹分离、孤独，不如意，烦闷，危难，遭厄，浮沉不定。为人慷慨，施惠招怨，劳而无功。凄惨孤独，其他好运者不多，有伤夭寿。\n在人格与变格时，个性强，较情绪化，婚姻不美满、闷骚，有早婚征兆，经商者独自经营较佳，防交通意外；在地格时，婚不顺、无贵人、血光之灾、刑伤、水灾、短命等。",
  "15": "◎15（福寿）：福寿拱照的立身兴家数。\n\n男女吉凶：男女皆大吉\n\n基业：天官、贵人、福星、官禄、进田、畜产。\n\n家庭：清静家风，圆满之象，子孙昌盛。\n\n健康：海底明珠，安稳余庆，健康自如。\n\n含义：此数为最大好运，福寿圆满之象，顺和、温良、雅量。多受福泽，德高望重，自成大业，富贵荣华，吉祥有德，繁荣兴家的大吉数。在人格与变格时，忠厚老实，脚踏实地。做事不积极，口才不好，重承诺，男帅女美，忌懒惰。\n但财运特佳，金钱有余，离祖越远越发达。人缘特好，易得人助。",
  "16": "◎16（厚重）：兴家得助的贵数。\n\n男女吉凶：男女皆大吉\n\n基业：天官、贵命、家杰、进田、学士、豪侠、基产。\n\n家庭：春日花开，可望家庭圆满；男子有贤妻，女子不宜早婚。\n\n健康：花草逢春，易溺于色情，戒慎者可望安康长寿。\n\n含义：反凶化吉象。成首领，占上峰，雅量厚重，豪侠，足智多谋，善于协调，集名望。能服从，为大事大业可成，富贵发达的好表示。在人格与变格时，个性强，正直不认输，有领导能力。\n重承诺，铁齿，吃亏有朋友，有名有利，发展步步高升。人缘特佳，易得人助。",
  "17": "◎17（刚强）：突破万难的刚柔兼备数。\n\n男女吉凶：男女皆大吉\n\n基业：天官、将星、威武、艺术、文昌。\n\n家庭：女性若能教养女德，贤慧者可望圆满。\n\n健康：心身健康，可望长寿。\n\n含义：权威刚强，有己无人，以致与人不和，如善于避开此短处，则为大吉。意志坚定，具突破万难的气节是其最大的优点。如过于无理、任性，恐反成失败，如果立志勇往向前，必成功而建大业。\n若陷过刚而变固执，必招厄患，切要警戒。妇女有此数者易流于男性，如果能涵养女德，存心温和，福禄自然随之。但先天条件弱的妇女，反要用此数为妥。\n在人格与变格时，性格刚强，爱面子，不认输，劳碌，赚大钱，铁齿，勤勉上进，有耐力。少有朋友相助，略感孤独。女性若养柔德者通达。",
  "18": "◎18（铁镜重磨）：有志竟成的内外吉数。\n\n男女吉凶：男女皆大吉\n\n基业：将星、文昌、太极、畜产、财帛、技艺。\n\n家庭：有祖宗荫庇之。心慈口硬，宜守和，不可望圆满。\n\n健康：心身健全，如万年蛇，可望长寿。\n\n含义：铁石心，具备发达运，有权力、智谋。志向一立，必破诸难，博得名利。但自我心强，乏包涵力。要戒坚刚，诱发非难。宜养柔德，且惧险勿临，则目的贯彻，功名成就。\n在人格与变格时，性格内刚，自尊心强，爱面子，财禄旺，铁齿，不听别人的劝告。在地格时，学业好，勤勉、上进，有耐力。",
  "19": "●19（多难）：遮云蔽月的辛苦重来数。\n\n男女吉凶：男女皆半凶\n\n基业：官禄、进田、红艳、财帛、智谋、凶危、破财。\n\n家庭：家内朝思暮改，兄弟成吴越，须思手足情，应多注意。\n\n健康：风云蔽月，病弱、刑罚、杀伤、短命，天格五行属金水者可望安康。\n\n含义：有多智谋、善活动的素质。虽有兴大业、博得名利的实力，但易发生意外的陷害，内外不和，困难苦惨不绝。如果主运有此数又乏其他吉数以相助，则多陷病弱、孤寡，甚至有夭折、妻子死别、刑罚、杀伤等灾。\n为万事挫折非命至极，故也叫短命数。但先天需金水者，可成巨富、怪杰、伟人。在地格时，少时多病弱，如经过生死之灾可免父母短寿，否则 27 岁前父母就很难双全，但也有离婚保命者。\n易出军警、执法部门与黑道人物，命硬三分。人格与变格有此数者，多性直、聪明，能力强；财来财去不留身，先成后败，一生常遇逆境之折磨，灾后多富成功。易受朋友拖累，与异性有感情上之纠纷困扰，有喜好投机之象。",
  "20": "△20（屋下藏金）：非业破运的空虚数。\n\n男女吉凶：男女皆凶\n\n基业：官星、部将、美术、智能、红艳、凶象。\n\n家庭：亲情不立，兄弟相隐，离祖成家，凡事百忍则家中平和。\n\n健康：泥身进海，难以为继。天、人、地三格相克者命运多难，病弱。金木者安全。\n\n含义：离祖成家，一时幸运发达，物将坏之象。具有短命非业的诱导，所谓大凶之运，一生不得平安，灾祸频临，不如意，陷于逆境。或导致病弱、短命、非业、破灭，不能支持一家者；或幼时别亲，而陷困苦或叹子女的不幸；\n或男女丧失其配偶。在人格与变格时，自尊心重，死要面子，婚姻不美，婚后多成怨偶。残疾之数，文职幸运，艺界有名利，喜好投机之象。漏财，浪费金钱倾向，品行不端者，会因犯罪受罚。",
  "21": "●21（明月中天）：明月光照，体质刚健，独立权威数。\n\n男女吉凶：男吉女半凶\n\n基业：天官、太极、文昌、哲学、财库、福禄、首领、君臣、富翁。\n\n家庭：六亲和睦，有子嗣之惠；若女人不为吉，用则破夫运。\n\n健康：秋月芙蓉，壮年健壮、长寿。\n\n含义：风光霁月之象，万物形成自立之势。独立权威，能为首领之运。为人尊仰，享受富贵显荣。路径属渐进发展，中途难免相当苦心，步步而进，宛如登梯一样。立业兴家，大博名利，乃贵重的吉数。\n因系伟大的首领格，妇女得此数者，反招灾害。按《易经》上观点女性属阴，应从男性，是为先天的补数。如具备首领之运，即妻凌夫之格。\n阴阳生出暗斗，自然不得安宁，故夫妻难免时常反目，或喜极余庆，且妇德为备，家庭圆满；则非夫克妻，妻便克夫，所谓两虎相斗，必无双全者。慎之，戒之。\n在变格时，仁慈心，心肠软，男命首领运，节制力不够者会因异性关系而困扰；女性，可能因事业心强而迟婚。人格有此数者，离异、孤寡或夫妻时常反目。",
  "22": "●22（秋草）：秋草逢霜的斗争数。\n\n男女吉凶：男女皆半凶\n\n基业：远洋、天乙、君臣、将星、劫煞、破财。\n\n家庭：六亲无力，自立成家。\n\n健康：常有暗疾，三好四怯无医或短命。\n\n含义：百事不如意，志向半途而废，多属懦弱，正如秋草逢霜之象。困难，病弱无气力，陷孤独，逆境不平常，但也有伟人、豪杰出此数者，不过其人生多波折。在变格时，多在中年招病灾、短命等。",
  "23": "●23（壮丽）：旭日东升，发育旺盛数。\n\n男女吉凶：男吉女凶\n\n基业：首领、君臣、暗禄、财库、进宅、学士。\n\n家庭：男人圆满，女人则零落，人格此数多克夫。\n\n健康：男人可望健康，女人则香闺零落。\n\n含义：伟大昌隆之运，威势冲天之象。微贱出身，逐渐长大，终至首领。有如凯旋之将，猛虎添翼之势。权力旺盛，致胜事业，功名荣达，大志大业可成。但平常气血强旺，临事恐过度而为憾。\n然而感情锐利，壮丽可爱，实属贵重的运数。但女性有此则不及此，其理由同于二十一数，妇女凡主运以及他格有此数者，难免转成零落而绣榻悲寒也。\n在人格与变格时，男命勇敢果决，喜欢领导别人，吃软不吃硬，脾气倔犟，情绪化，易被激将，若自制力不够，有风流好淫，受异性的困扰；女命则美貌如仙，异性缘广而生烦恼，克夫，孤独。",
  "24": "◎24（掘藏得金）：家门余庆的金钱丰盈数。\n\n男女吉凶：男女皆大吉\n\n基业：大官、福星、文昌、企业、财库、君臣、工商、富贵。\n\n家庭：不依祖业而立身，家庭圆满，兄弟和睦，但应保持无私。\n\n健康：松柏常青，可望长寿。\n\n含义：路途多有崎岖，实为难免。然而策略、智谋出众，白手可以成家，财源广进，到老愈丰，子孙继承余庆的福运。在人格与变格时，为富贵之人，做事认真，节俭、劳碌，个性不弱，完美，喜罗曼蒂克气氛，有早婚征兆。\n经商独立较佳。",
  "25": "○25（英俊）：资性英敏的刚毅数。\n\n男女吉凶：男女皆吉\n\n基业：君臣、首领、福星、文昌、企业、财禄、技艺、财库、进田。\n\n家庭：平和而谦虚者，家庭圆满，子孙昌盛。\n\n健康：健康自在，天、人、地三格善良者可望长寿。\n\n含义：资性英敏，有奇特的才智，唯性情不平衡而偏重于一方，言语多少有点棱角，柔中带硬，或者有怪脾气，是故涵养不足者，多成怪人，与外人打交道缺谦虚。以英俊广才，能克己者成大业。\n倘任意气用事，傲慢无礼，恐弄吉成凶。在人格与变格时，表示才华显著，灵性高，人性正直，有宗教缘，聪明。涵养不足者讲话易伤人，受克者婚姻、身体、钱财必败其一。",
  "26": "△26（变怪）：变怪奇异的豪侠数。\n\n男女吉凶：男女皆凶\n\n基业：豪侠、君臣、官禄、侠义、红舞、财库、凶危。\n\n家庭：亲情无义，妻子无助，若子女温顺可得圆满。\n\n健康：大多破家病弱，先天缺金者，可望平安，男子有双妻之虞。\n\n含义：属波漾重叠，数奇怪变的英雄运格。有义气侠情，然而变化常多，风波不息。此数中人，临万能，越死线，而奏大功者有之；力不足，随波逐流，碰波折而破产、亡家者有之。又因为他格的配合，或陷放逆、淫乱、短命；\n或者丧配偶、衾褥生霜；或丧子女，膝下零丁；属大都不得顺境的数运。但不少怪杰、烈士、伟人则有出其格者。在人格与变格时，坏点子多，不走正道；个性强，情绪化严重；六亲缘薄，不易早婚。\n女眼光高，有特别好色之倾向；万丈雄心志气高，有名扬八方的可能，但也可能凄惨无比。",
  "27": "●27（增长）：欲望无止境，宜静待时数。\n\n男女吉凶：男女皆半吉\n\n基业：天官、将军、师长、学士、文昌、凶厄、破财、残疾。\n\n家庭：六亲不得力，兄弟远离。\n\n健康：肺病、刑罚、心脏病、短命，天格五行为水土者可望安全。\n\n含义：自我心强，多受诽谤攻击，而易致失败。所谓遭难运，大多为半路中折之象。始以其智谋，努力奋斗，博得名利；待过中年，势渐趋大，内外酿出不和，难以发达到老。\n假使自身温顺、富有，也不会避开背后是非不息，也因其他运的关系或刑罚，死于逆难等。在人格与变格时，女命无公婆及读书缘，暗桃花，婚姻感情易受挫折；\n个性主观，自私心强，但精明，反应好，善于与异性交际，是个情调专家；喜好投机之象。",
  "28": "●28（阔水浮萍）：豪气生离的行踪无定数。\n\n男女吉凶：男半吉女凶\n\n基业：天官、将星、学士、红艳。\n\n家庭：亲属多忌怨，兄弟少联络，子女别离。\n\n健康：天、人、地三格不良者病灾、残疾、发狂，天、人、地三格善良者无大害。\n\n含义：堪称遭难运，有一种英雄气概，多于波澜起伏，但难逃非难、诽谤。时或厄难袭来，而致伤；或丧失配偶，相克子孙；也可能有自幼别亲者。总之大都有祸乱，争论不和、逆难、刑罚等，灾祸相接，终生劳苦。\n妇女人格与地格有此数者多陷于孤寡独身、难成家或家庭不幸的运格。个性强，爱情不专；讲话太直接，易得罪人；事业先成后败。女命多无公婆，易受伤害或遇危险事件，有与配偶分居或孤寡之凶兆。",
  "29": "●29（不平）：急舟顺展的大立功数。\n\n男女吉凶：男女皆半吉\n\n基业：天官、太极、君臣、天厨、将星、财帛、文昌、深谋、富翁。\n\n家庭：乏祖力，地格为火时，有乏子息或不和。\n\n健康：天格五行为金而天、人、地三格善良者，可望安康；土火者有弱病之虑。\n\n含义：智谋优异，奏功受福之格。财力、活动力俱备，成就大业之兆。但是不足、不平的念头不绝，任意行事，欲望无止境，多易弄巧成拙。至于妇女，都流于男性，或者造成荒唐、猜疑之灾，切要慎戒之。\n在人格时，疑心病重，完美主义，易挑剔，不适合女性之首领数。在变格时，智慧超乎常人，易有牢骚及贪心，欲望太多而不知足。喜好投机之象。",
  "30": "●30（非运）：绝境逢生的运途分歧数。\n\n男女吉凶：男女皆半吉\n\n基业：官星、将星、文昌、豪放、红艳、血光、灾厄。\n\n家庭：亲情不亲，夫妻不相合，难同白头。\n\n健康：刑罚、外伤、残疾，天格五行为金者可安然。\n\n含义：浮沉不定，凶吉难分。因其他运的配合，或者成功，或者沉于失败，故在吉运者，成功自至；数理不良者，不知不觉之间陷于失败。其地不可测，突然别开生面者有之，就像开矿探险一样，大成大败，具有侥幸。\n另外也有孤独、丧失妻子、短命者。在人格与变格时，有宗教、五术缘，个性主观、铁齿，才能佳。泌尿系统易有毛病。喜好投机之象。",
  "31": "◎31（春日花开）：智勇得志，可享清福数。\n\n男女吉凶：男女皆大吉\n\n基业：太极、君臣、将星、学士、文星、田宅、祖业。\n\n家庭：可望幸福，子女多萌，地格被克者人不遇。\n\n健康：身心健康，可望长寿。\n\n含义：智、仁、勇俱备，意志坚固，千挫不挠，脚步踏实，能成就大业的运格。可率众人，博得名誉，繁荣、富贵、幸福，属温柔、平静、运势强大的首领运。\n在人格与变格时，仁慈道德，贤妻良母型，正点子多，铁齿，是个好顾问，给人指正道，运势特佳，凡事顺利。",
  "32": "◎32（宝马金鞍）：侥幸多能的意外惠泽运数。\n\n男女吉凶：男女皆大吉\n\n基业：天德、月德、君臣、将星、文星、学士、文昌、进宅、祖业。\n\n家庭：家门隆昌，可能圆满；子孙旺发，男有双妻之格。\n\n健康：可能安康，而天、人、地三格不善者略有患。\n\n含义：侥幸多望之格，若能得长辈提携，其成功势如破竹。且品性温和，大有爱护他人之德，家门隆昌、繁荣，至上吉数。在人格时，桃花运强；在变格时，仁慈、道德，劳碌，好管事，有危险可自动化解。与人合作经营好。",
  "33": "●33（升天）：家门昌隆，才德开展数。\n\n男女吉凶：男吉女凶\n\n基业：天官、臣将、部长、文昌、学士、田宅、富翁。\n\n家庭：可望幸福，身强口硬，妇女用则孤寡。\n\n健康：可望健康，天、人、地三格不善或不合天格五行者，病患亦有之。\n\n含义：鸾凤相会之象，形成确定之意。多功威、智谋，刚毅、果断，如旭日东升，旺盛、昌隆至极，属名闻天下的吉祥数。但如果过刚毅，反致误事，而且过贵重，常人恐不堪受。\n又物极必反，繁荣的反面为黑暗，勿轻用之，妇女断不可用，用则孤寡。在人格与变格时，主桃花运强，主观情绪化强；在变格时，名利双收，男命勇敢、果决，女命貌美。",
  "34": "●34（破家）：破家亡身的见识浅少数。\n\n男女吉凶：男半吉女凶\n\n基业：臣将、君臣、文昌、学士、破财、凶厄、破灭。\n\n家庭：家缘薄，妻子分离，忍耐可保平安。\n\n健康：短命、杀伤、刑罚、脑溢血、麻疹、发狂，天、人、地三格善良者也可以得安康。\n\n含义：属破坏的大凶运。乱离的祸象颇强，凶煞一到，便接连而来，事业生大凶、大困难、大辛苦，内外破乱，万事龊龌、衰败，悲痛无限。因其他数的配合关系，或病弱短命，丧失配偶，子女离别，刑伤，杀伤；或致发狂灾祸至极；\n为破家、亡身的最大凶数。在人格与变格时，男命有老板或领导，经营者独立较佳，劳碌命；女命婚姻不美、孤独、刑伤。在地格时，有早婚征兆，不如意，但大多少年时体弱多病，将因病而减其寿。",
  "35": "◎35（高楼望月）：温和平静的优美发展数。\n\n男女吉凶：男吉女大吉\n\n基业：将星、学士、文昌、艺术、财库、田宅、工商、温柔。\n\n家庭：上流家庭，可望圆满，被运格克者，病苦亦有之。\n\n健康：平安无事，三才不合者，有弱病之虞。\n\n含义：温良、和顺之象，有智达的能力，在文艺技术方面定能发展而奏功洋洋。若怀大志，欲为大事者，宜大振气力，彻底节义，以补不彻底的禀赋和权威号召力。\n因其缺少谋略气魄，故此数实为保守平安的吉祥数，所以此数最适合女性，为男性则倾向消极。在人格与变格时，白手生财，有计划多、实践少之缺憾。",
  "36": "●36（波澜）：风浪不平静的枉费心力数。\n\n男女吉凶：男女皆半吉\n\n基业：将星、学士、文昌、文相、破厄、凶煞、劫财。\n\n家庭：六亲不力，夫妻离合，子息宜迟，应多做善事以积德。\n\n健康：短命、病患、外伤、病疾，天、人、地三格善良者，可望安康。\n\n含义：为波澜重叠、浮沉万状的英雄运，为侠气、义情敦厚、舍自成仁之格。一生难得平安，辛苦困难多，袖手不进则不致大害。与其他运配合不善者，或病弱、短命、危难等无所不至。\n在人格与变格时，能力强但有志难伸，适合小投资，受人重视，万丈雄心志气高，有名扬八方之可能，但凡事要防凶。",
  "37": "◎37（猛虎下山）：权威显达，发展基业数。\n\n男女吉凶：男大吉女吉\n\n基业：将星、官禄、文昌、艺术、权利、祖业。\n\n家庭：家庭和睦圆满，女性略有烈强，宜守女德，则无大过。\n\n健康：长寿多，天格五行或人格克者，易患疾病，少数为心脏、肺、肝病。\n\n含义：独立、权威、忠实，奏功无比之象；主畅、通达，热诚、忠烈，得众信，破万难而成大业；慈祥有德，善发挥才能，享受天福之幸，终生富贵至极。但因权威独行，而难免有孤独之感，宜心存平和，留神静安。\n在人格与变格时，个性强，较主观，有才能及威严，讲话太直易受人误解，忌自私。",
  "38": "●38（磨铁成针）：意志薄弱的刻意经营数。\n\n男女吉凶：男女皆半吉\n\n基业：将星、学士、臣将、神童、技艺、凶煞、伤杀。\n\n家庭：亲属冷淡，兄弟无助，宜平和可圆满。\n\n健康：灾难、外伤、市病，天、人、地三格配合者尚可圆满。\n\n含义：非无大成，实乏统帅的威望，缺乏首领的才干，属于有志而乏力，不得众信，一种薄弱平凡之象。自然易陷于不幸、失意而难以成功，但向文学技术方面发展，则有较强的能力，故此数为艺术成功数。\n在人格与变格时，有文艺技术才能，做事虎头蛇尾，但学习能力极佳。",
  "39": "●39（富贵）：富贵荣华的变化无穷数。\n\n男女吉凶：男吉女凶\n\n基业：臣将、文昌、艺术、智能、财库、进田。\n\n家庭：安宁自在，可望圆满，子孙昌盛，天、人、地三格相克者则不圆满。\n\n健康：可望安康，天、人、地三格不善者有病弱。\n\n含义：此数为祸乱一过，反成幸福、贵重之格，权威、长寿，财帛丰富，德泽四乡，财富盈身，富贵至极；暗埋悲惨之象，所谓物极必反，切勿轻用之。妇女若有此数者必陷孤寡。\n在人格与变格时，早年劳碌，中年发达，自会超乎常人，易有牢骚及贪心，欲望太多而不知足，和异性有感情上之纠纷困扰。一生常遇逆境之折磨，女性戒之。",
  "40": "●40（退安）：谨慎保安的豪胆迈进数。\n\n男女吉凶：男女皆半凶\n\n基业：将星、文昌、学士、豪杰、胆量、凶灾、祸厄、劫财。\n\n家庭：亲情远淡，兄弟分离。\n\n健康：凶病、胃病、外伤，天、人、地三格善良者可弥补。\n\n含义：富智谋，有心机，然含不逊之心，乏声望，易受诽谤攻击。外于浮沉吉凶的歧路上，好危险投资，依其他运关系，有酿刑伤犯罪。犯病者有陷病弱，孤独短命者，有爱动反招失败，故为进而招祸。\n在人格时，事业成败不定，个性情绪化强；在变格时，聪明有胆识，遇事退让则安。",
  "41": "◎41（有德）：德高望重的事事如意数。\n\n男女吉凶：男女皆大吉\n\n基业：将星、太极、名人、老者、学士、学者、官禄、财库、福星。\n\n家庭：家庭圆满，子孙昌盛，地格被克者不遇。\n\n健康：可望健康长寿，天、人、地三格不善者不遇。\n\n含义：纯明、独秀的吉数，胆力、才谋具备，健全、有德、能成大业，顺利的最大好运数。在人格与变格时，善良、慈爱，有宗教缘，聪明、有胆识。",
  "42": "△42（寒蝉在柳）：数十艺不成的穷困至极数。\n\n男女吉凶：男女皆凶\n\n基业：君臣、部将、官星、文昌、劫煞、灾厄、凶变。\n\n家庭：亲情无义，朋友无缘，妻子反目，天、人、地三格善良者则无妨。\n\n健康：病弱，天格五行为火、水者可望安康，但须天、人、地三格善良。\n\n含义：博识、多能、有技艺，精通世情，无奈十艺九不成，多薄弱、不如意，缺乏自信心，为寂寞、悲苦之象，失意之状。如果专心进取，或者可以成功，不然必大失败，此数中也有孤独、病弱者。\n在人格与变格时，聪明、多才多艺，但通财而不专。对爱情要专一，否则有可能导致婚姻不睦。",
  "43": "●43（散财）：须防邪途、灾祸重数。\n\n男女吉凶：男女皆半凶\n\n基业：将星、文字、学者、凶星、灾厄、伤残。\n\n家庭：妻弱无助，子多不肖，心心相印，天、人、地三格善良者无妨。\n\n健康：病弱、外伤、短命，天、人、地三格善良才可平安。\n\n含义：散财、破产运，因循姑息，有如夜雨之花、薄弱、散漫之象，虽有才能、知识，意力不确定，诸事不能随行。外观幸福，内多困苦，表面依然成事，里面不堪设想。如果妇女有此数，加上其他关系，必逐荒凉。\n在人格与变格时，一生很难聚财，爱面子，喜凑热闹，玩弄权势，易堕落而荒淫多情。",
  "44": "△44（烦闷）：须眉难展的力量有限数。\n\n男女吉凶：男女皆凶\n\n基业：文昌、财破、灾厄、凶厄。\n\n家庭：骨肉相连，兄弟不和，能忍则平和。\n\n健康：发狂、刑罚、病灾、烦闷、遭难、短命，天格五行为土者，可望平安。\n\n含义：破家、亡身的最恶数，暗隐惨淡之运，破坏、乱离之意，因此万事不能如意。逆境、烦闷、劳苦、患病、残疾、遭难，家属则生离死别，或因其他运的关系而发狂、短命。\n但乱世出怪杰、伟人、烈士、孝子、大发明家等，往往出自此格数。在人格与变格时，悲观消极，讲话不实在，诸事不顺，破财等。喜好投机之象。",
  "45": "◎45（顺风）：新生泰和的万事如意数。\n\n男女吉凶：男女皆大吉\n\n基业：部将、君臣、文昌、学士、艺术。\n\n家庭：可望圆满，子孙昌盛。三才不善者不遇。\n\n健康：可望圆满，子孙昌盛，天、人、地三格不善者不遇；安康长寿，人格被克者不遇。\n\n含义：顺风扬帆之象，经纬深，智谋大，可遂大志大业，克破万难而成功，富贵繁荣至极。但若与运的凶数结合，即如浪里失舵船，易遭灾难。在人格与变格时，一生顺利成功，受克者则无主见，有任人摆布之象。",
  "46": "●46（浪里淘金）：须防复失的离祖破家数。\n\n男女吉凶：男女皆半凶\n\n基业：臣将、将星、学士、豪杰、文昌、凶厄、崩山。\n\n家庭：亲多往且子孙宜迟，天、人、地三格善良者可弥补。\n\n健康：刑罚、病弱、短命、外伤、暗伤，天、人、地三格善良者望健。\n\n含义：载宝沉舟之象，乏力、薄弱、悲衰、困难、辛苦，破坏、失败者多，然而属一类变怪的命运，有大艰难尝尽后而又成功者，或依其他命运关系，致陷孤独、刑罚、病患、短命等灾祸，总之是难免于不幸的命运。\n在人格与变格时，特别注意意外凶灾。有喜好投机之象。",
  "47": "◎47（点石成金）：开花结果的权威进取数。\n\n男女吉凶：男女皆大吉\n\n基业：君臣、将星、文昌、学士、艺术、高傲、食禄、财库。\n\n家庭：家庭圆满，然时有争执，天、人、地三格不善者，和睦相处。\n\n健康：可望长寿、健康，天、人、地三格不善者，也有病弱、短命的可能。\n\n含义：开花之象，祯祥、吉庆之数，可享天赋的幸福，与朋友合作以成大事大业，真是进可以攻，退可以守，在总格时，可遗禄于子孙的吉运。",
  "48": "◎48（古松立鹤）：德智兼备的出身清贵数。\n\n男女吉凶：男女皆大吉\n\n基业：将相、官禄、文昌、学士、文艺、财库。\n\n家庭：家庭圆满，子孙满堂，天、人、地三格不善者不遇。\n\n健康：良好，可望长寿，天、人、地三格不善者不遇。\n\n含义：才望、谋略齐备，内含坚刚，为功利荣达的吉数。宜为人的顾问，威望洋洋，乃师数也。在总格时，子孙多出官贵之人。",
  "49": "●49（转变）：吉凶难分的不断辛苦数。\n\n男女吉凶：男女皆半凶\n\n基业：臣相、将星、文昌、智谋、学士、凶象、散财。\n\n家庭：六亲得力，子自宜退。\n\n健康：凶灾、病灾、外伤、短命，天、人、地三格不善者可补救。\n\n含义：处吉凶的歧路，吉临则吉，又生大吉；凶来则凶，又变大凶，所以成败得失极其浩大。有处大凶而其他方面化吉者，其幸福与不幸，专靠天、人、地三格配合的好坏，以及其他运的联系显现，多陷落于灾祸。\n在总格时，子孙多出大起大落之象。",
  "50": "●50（小舟进海）：吉凶参半，需防倾覆数。\n\n男女吉凶：男女皆吉后凶\n\n基业：将官、文昌、财钱、灾祸、离愁、散财。\n\n家庭：亲属多而无助。\n\n健康：刑罚、杀伤、意外之灾，外伤、白痴、狂癫等疾。\n\n含义：成败之象，先得五字的数理庇荫，而成大业，享受富贵，后由盈数（凡十谓之盈数）的暗示诱导而成陷失败，亡身破于晚年，凄惨至极。若其他运又凶数者，则是惨上加惨。杀伤、离异、孤单频临，或至于刑罚。\n在总格时，家运先旺后衰。",
  "51": "●51（沉浮）：盛衰交加的竭力经营数。\n\n男女吉凶：男女皆半吉\n\n基业：文昌、学士、节度、时禄、劫煞、败退。\n\n家庭：时有争执、灾祸、病患，天、人、地三格善者，安康、自在。\n\n健康：人格被克者，灾厄病患。三才善者，安康自在。\n\n含义：一盛一衰之象，必然可得昌盛，博得一时名利，然后发现运中自然的凶兆，到晚年出现挫折困苦，遂至失败。如其他运格配合良好，加以内心觉悟，兢兢业业，小心从事，平生切记「满招损，谦受益」，自重可保平安。\n在总格时，子孙多赚辛苦钱。",
  "52": "◎52（达眼）：先见之明，理想实现数。\n\n男女吉凶：男女皆大吉\n\n基业：元帅、医师、文昌、技艺、财库、官禄、财星。\n\n家庭：幸福，顺从行孝，子女和睦，天、人、地三格不善者不遇。\n\n健康：可望健康、长寿，人格被克者不遇。\n\n含义：属于运势伸展之象，势能强大，无中生有的运数，有先见之明，计划必成。眼能察时世，富投机心，有谋略，他人之难不为难，实现大志大业而名利双收，因为有眼光而成功。在总格时，子孙多出官贵之人。",
  "53": "●53（曲卷难星）：忧愁困苦，内心忧愁数。\n\n男女吉凶：男女皆半凶\n\n基业：伟人、学者、时禄、磨难、灾祸、劫煞。\n\n家庭：亲眷寡情，乏子息。\n\n健康：病灾、祸患、外伤、刑罚，天、人、地三格善者或可弥补。\n\n含义：外观俨然吉庆祯祥，内实祸患甚多，若非前半生不幸而后半生幸福，便是前半生富贵而后半生落魄，及盛衰参半的运数。一旦陷入凶煞，大多家破身亡，即使得吉数他运相救，亦仅得小安而已。在总格时，子孙多不顺、难孝。",
  "54": "△54（石上栽花）：多难悲运的难望成功数。\n\n男女吉凶：男女皆凶\n\n基业：文昌、技艺、凶灾、劫煞、时禄、灾祸。\n\n家庭：父母如过客，兄弟似残星，和睦相处，亦可无大过。\n\n健康：病灾、遭难、残伤、短命，三才善者可望健全。\n\n含义：为大凶煞暗示。悲惨不绝，不和、损伤、忧闷频来，遂至倾家荡产，或患废疾、刑罚、短命、横死、孤独等。在总格时，家庭表面兴盛，内里空。",
  "55": "△55（善恶）：外美内恶的和顺不实数。\n\n男女吉凶：男女皆凶\n\n基业：非官、技艺、文昌、学者、灾祸。\n\n家庭：亲眷忌，父母老病，尽心忠孝可无大过。\n\n健康：天、人、地三格善者可健全，否则不过安康。\n\n含义：五数为最吉数，五上添五乃是最吉重叠，反而生凶相了，故表面颇为隆盛，而内里则是灾祸叠生，凡事不能安心，危难、别离、病难等无所不至，因而是吉凶相伴的运格。\n志弱者绝无立身之地，善能震雄威，坚心为业志，打破万难也可能有成功之日，其中也有前半世幸福。在总格时，家庭成员大起大落。",
  "56": "△56（海里行舟）：初历尽困苦，四周障碍数。\n\n男女吉凶：男女皆凶\n\n基业：豪杰、文昌、时禄、文艺、红艳、灾祸、伤身。\n\n家庭：不可靠亲享福，宜离祖自立。\n\n健康：外伤、病难、残废、短命，天、人、地三格善者可望健全。\n\n含义：缺乏实行的勇气，缺乏进取的精神，损失、灾祸等，是祸不单行者。万事龈龋，财力不足，乃是最凶的运格。在总格时，难享天伦之乐。",
  "57": "●57（日照春松）：寒雪青松的最大运数。\n\n男女吉凶：男女皆半吉\n\n基业：官禄、文昌、学士、艺能、时禄、财库、进田。\n\n家庭：父母尊严，时有冲突，天、人、地三格善者，可得圆满。\n\n健康：自在，可望长寿，天、人、地三格不善者不在此数。\n\n含义：寒莺吟春之格，资格刚毅，获天赋之幸福而招致富贵，但这一生必遭大难一次，然后得享吉祥、繁荣，百事可以如意。在总格时，家庭多破，子孙之运起伏大。",
  "58": "●58（晚行碰月）：先苦后甜，气宏扬名数。\n\n男女吉凶：男女皆半吉\n\n基业：官禄、文昌、学士、技艺、灾厄、伤残。\n\n家庭：亲情少，兄弟离，须互相信任。\n\n健康：伤残、刑罚、外伤，天、人、地三格善者可望平安。\n\n含义：浮沉多端，祸福无常，所得福分，必经大失败大患难后方能显著，家破产亡后方得富贵荣华，大都蔗根生甜。晚年享受安庆。在总格时，老年可享天伦之乐。",
  "59": "△59（寒蝉悲风）：须防外患的时运不济数。\n\n男女吉凶：男女皆凶\n\n基业：官星、福星、文昌、智能、灾厄、伤残、财库、破厄。\n\n家庭：亲情无缘，子女背井离乡。\n\n健康：病患、短命，天、人、地三格善者可望平安。\n\n含义：乏耐心，缺勇气，意志衰退，无办事的才能，终于悲苦一生。在总格时，家庭多破败。",
  "60": "△60（无谋）：争名夺利，黑暗无光数。\n\n男女吉凶：男女皆凶\n\n基业：官星、将星、文昌、智能、技艺、灾厄、伤残。\n\n家庭：祖宗无基，亲友无情，兄弟无缘，天、人、地三格善者可弥补。\n\n健康：外伤、病疫、短命等。\n\n含义：属晦冥黑暗、摇动不安的凶象，方向不定、尽任风波的运格。无谋不算而计划岂能成功，故难免失败、苦恼或刑罚、杀伤、伤疾、短命等。在总格时，家中子孙多命短。",
  "61": "○61（牡丹芙蓉）：名利双收的修行积德数。\n\n男女吉凶：男女皆吉\n\n基业：将星、文昌、财库、财帛、破厄。\n\n家庭：自立成家，衣食富足。\n\n健康：可望长寿、安康，天、人、地三格不良者不遇。\n\n含义：名利双收，繁荣富贵的吉数，无奈骄傲不逊，致酿成内外不和，家庭反目，兄弟无情。表面装饰堂皇，里面空虚。如果能修德慎行，且守和顺，自可防患于未然，享天赋的幸福，一生受尽祯祥。在总格时，晚年可享子孙福。",
  "62": "△62（衰败）：基根虚弱的艰困厄数。\n\n男女吉凶：男女皆凶\n\n基业：国印、文昌、虚度、将星、技艺、灾厄。\n\n家庭：亲情疏远，骨肉分离。\n\n健康：伤残、外伤、刑罚、短命、灾厄，天、人、地三格善者可安全。\n\n含义：内外不和，缺乏信用，志望难达，渐进衰败之境。意外灾害频来，属身弱家败、步步凶惨之数。在总格时，家运难享，子孙多败。",
  "63": "◎63（舟归平浦）：富贵荣华的身心安泰数。\n\n男女吉凶：男女皆大吉\n\n基业：官禄、将星、文星、艺能、财库、田宅、商工。\n\n家庭：子女多孝，顺从敬爱，圆满之象。\n\n健康：身心健康，可望长寿。\n\n含义：万物承惠雨露而发育壮大之状。属不费心神，万事如意，荣显可传子孙的最大吉数。在总格时，子孙多出官贵之人。",
  "64": "△64（非命）：骨肉分离，孤独悲恨数。\n\n男女吉凶：男女皆凶\n\n基业：将星、学士、技艺、灾厄、破财、劫煞。\n\n家庭：六亲多忧，妻子见破。\n\n健康：水厄、刑罚、病患、外伤，天、人、地三格善者可平安。\n\n含义：此数为破坏、灭离、沉滞的凶象。有意外灾祸袭来，或骨肉离散，或病患非命临身，人生难得安心。在总格时，家运难享，大多都不长寿。",
  "65": "◎65（大流归海）：富贵长寿的志在四方数。\n\n男女吉凶：男女皆大吉\n\n基业：臣君、将星、官禄、文昌、技艺、财库、田宅、时禄。\n\n家庭：祖业有根基，子孙昌杰，天、人、地三格不善者不遇。\n\n健康：多施恩德则能益寿延年、安康自在。\n\n含义：天长地久，家庭隆昌，福寿绵长，事事成就，一生平安，多贵重的气运。在总格时，子孙多出官贵之人。",
  "66": "△66（岩头步马）：内外不和的多祸失福数。\n\n男女吉凶：男女皆凶\n\n基业：将星、豪杰、灾厄、崩山、散财、破财。\n\n家庭：六亲冷淡不相投，兄弟远离。\n\n健康：刑罚、外伤、亡身、残伤、短命。\n\n含义：进退失自由，内外不和，艰难不堪，损伤灾祸交至，大有家破灭亡的凶相。在总格时，家运难享，多无后人。",
  "67": "○67（通达）：利路亨通的坚强数。\n\n男女吉凶：男女皆吉\n\n基业：君臣、将星、文昌、硕士、刚性、艺能、财库、进田。\n\n家庭：父母多荫，子女多孝，圆满幸福。天、人、地三格不善者时有争执，宜守和平。\n\n健康：安全，可望长寿，先天五行为大业。天、人、地三格不善者有时患呼吸器官疾病。\n\n含义：受长辈上级的援助，万事无障而达到目的，是天助的幸运，实现志望。家道繁昌，富贵好运数。在总格时，老年子孙昌盛荣达。",
  "68": "○68（顺风吹帆）：兴家立业的宽容好运数。\n\n男女吉凶：男女皆吉\n\n基业：将相、学士、文昌、财帛、荣誉、暗禄、进田、节度。\n\n家庭：幸福，天、人、地三格不善者无此数。\n\n健康：良好，天、人、地三格不善者得疾病。\n\n含义：智虑周全，志向坚定，勤勉力行，发展奋进之象。有发明的才能，集众信，愿望发达，名实而全的运数。在总格时，子孙多出官贵之人。",
  "69": "△69（非业）：坐立不安处世多难数。\n\n男女吉凶：男女皆凶\n\n基业：将星、财帛、学士、文昌、技能、艺术、破厄、劫财。\n\n家庭：六亲不相投，兄弟难相处，不宜心直口快。\n\n健康：刑罚、外伤、病灾、伤残，天生五行为金者可望平安。\n\n含义：穷迫、滞塞、逆境之数，缺乏坚定信念，灾祸交至，摇动为安，致陷于短命、病疾或尝尽痛苦而死。在总格时，家运难享，子孙不旺。",
  "70": "△70（残菊逢霜）：家庭衰退的晚景凄凉数。\n\n男女吉凶：男女皆凶\n\n基业：官星、学士、文库、巧星、财库、破厄、劫禄。\n\n家庭：父母难当，兄弟无助，妻子宜尽。\n\n健康：病患、残疾、外伤，先天五行为金木者为健全。\n\n含义：险恶亡灭之象，一生惨淡，忧伤不绝，有空虚寂寞之感，难免杀伤、残疾、刑罚、短命、离散等灾厄。",
  "71": "△71（石上金花）：没有实质的磨神耐劳数。\n\n男女吉凶：男女皆凶\n\n基业：技艺、文昌、学士、破厄、劫禄。\n\n家庭：时有争执，宜守平和。\n\n健康：外伤，少些病患，天、人、地三格善者安康。\n\n含义：备有生成的吉运，自应享受富贵福禄，无奈内心劳苦甚多，缺乏实行贯彻的精神，进取的勇气稀少，致陷失败，故称吉凶参半的运数。在总格时，可享天伦之乐。",
  "72": "△72（劳苦）：先甜后苦的万难忍受数。\n\n男女吉凶：男女皆凶\n\n基业：技能、官禄、工商、财帛、田宅、破厄。\n\n家庭：亲属冷淡，妻子宜迟。\n\n健康：可望健康，天、人、地三格不善者无此数。\n\n含义：阴云遮月之象，快乐贫穷而兼之数，其前半生幸福，后半生凄惨，外观虽吉，内里生凶。在总格时，甚至有晚年家破人亡者，平素戒贪心，可免陷困苦。子孙多破败。",
  "73": "●73（无难）：志高力微的努力奋斗数。\n\n男女吉凶：男女皆半凶半吉\n\n基业：技艺、文昌、艺术、时禄、厄星、红艳。\n\n家庭：六亲无缘，夫妻旗鼓相当，难为儿女。\n\n健康：良好，须防肝病和眼疾。\n\n含义：盛衰交加之象，无实行贯彻之勇，徒有高志而无成事之能，然而天生福气，大都终世平安。在总格时，家运难享，子孙难立。",
  "74": "△74（残菊经霜）：沉沦逆境的秋叶落寞数。\n\n男女吉凶：男女皆凶\n\n基业：技艺、文昌、时禄、破厄、红艳、劫禄。\n\n家庭：妻子不知心，亲情无助，宜开阔心胸。\n\n健康：时遇伤残、病患、刑罚、短命，先天五行为土者安康、自在。\n\n含义：无能无智，仅取得衣食，真世上无有之辈。且易生意外之灾，辛苦繁多，沉沦逆境，哀叹命运。在总格时，难享天伦之乐。",
  "75": "●75（退守）：守者可安，发迹甚迟数。\n\n男女吉凶：男女皆半吉\n\n基业：将星、学士、时禄、破厄、灾动、文昌。\n\n家庭：可望圆满。\n\n健康：安康，天、人、地三格不善者有病患。\n\n含义：虽有自然之吉相，无奈策划未成，若要做大事，便招失败痛苦，退守可保吉祥，进取必陷失意灾厄。在总格时，老年可享子孙福。",
  "76": "△76（离散）：倾覆离散，虽劳无功数。\n\n男女吉凶：男女皆凶\n\n基业：豪杰、文昌、将星、劫禄、破财。\n\n家庭：六亲无缘，夫妇分离，乏子息。\n\n健康：外伤、废疾，先天五行为金者平安。\n\n含义：内外不和，骨肉分离，逆境凶煞无限，倾家破产亡身的悲运数。故多病弱、短命、妻子离愁。在总格时，子孙多败。",
  "77": "●77（半吉）：家庭有悦的半凶半吉数。\n\n男女吉凶：男女皆半吉\n\n基业：将星、财帛、劫禄、破厄。\n\n家庭：六亲不得力，子息宜迟。\n\n健康：须防肺病，先天五行为土者平安。\n\n含义：多获上级援护，幸福享至中年，然后陷落不平，悲叹灾厄，如果有悲运于前半生者，后半生却反得吉祥。在总格时，子孙多不旺。",
  "78": "●78（晚苦）：晚境凄凉的功德光荣数。\n\n男女吉凶：男女皆半吉\n\n基业：将星、学士、技艺、破厄、劫财、突破。\n\n家庭：亲缘少，兄弟疏，宜多联络。\n\n健康：宜防呼吸病、负伤、遭难，先天五行为水土者，可望健全。\n\n含义：福祸虽有参半，凶相较多一些，天生智能齐备，是以中年以前成功发达，乃至中年后，渐自衰退，陷于困苦、大悲惨的暗示。",
  "79": "△79（云头望月）：挽回乏力的身疲力尽数。\n\n男女吉凶：男女皆凶\n\n基业：将星、学士、时禄、破厄、灾厄、文昌、劫财。\n\n家庭：亲眷疏、兄弟不和，凡事谨慎则平安。\n\n健康：外伤、病患，先天五行为金木者可望安全。\n\n含义：穷迫不伸的逆境，精神不定，缺乏实行的能力，乏贞节，失信用，受攻击非难，为世所弃，成为废人，但身体却健康。在总格时，子孙多败。",
  "80": "△80（遁吉）：凶星入度的消极缩小数。\n\n男女吉凶：男女皆凶\n\n基业：将星、技艺、学者、时禄、破财、灾厄。\n\n家庭：家中口舌多，不可多言。\n\n健康：病患多，天、人、地三格善者可望平安。\n\n含义：一生困难辛苦不绝，病患、刑伤、夭折者多，但早入隐遁的生活者，可以安心立命，化凶转吉。在总格时，官运难享。",
  "81": "◎81（万物回春）：万物回春，还原复始的积极盛大数。\n\n男女吉凶：男女皆大吉\n\n基业：天福、天官、赐禄、财库、将星、技艺、文昌。\n\n家庭：子女俱佳，兄弟圆满，家庭和睦。\n\n健康：身心健全，可望长寿，天、人、地三格不善者可能患病。\n\n含义：最极之数，还本归元，故其数理相等基数 1。属于体力旺盛，庆幸万多，吉祥重叠，富贵尊荣的大诱导之数。## 注 81 数，还本归元，数理相等基数 1；\n82 数仍同 2 数，83 数又同 3 数，故凡 81 数以上者，除其盈数 80，将剩的数推理便可。例如 160 之数，扣去 80，尚余 80，便按 80 推理；\n又如 161 数，扣去 80 两次，所剩 1 数，就按 1 数判断即可，其他仿此。",
} as Record<number, string>;

export const NUMEROLOGY_81_META: Record<number, Numerology81Meta> = {
  "1": {
    symbol: "◎",
    title: "宇宙起源",
    subtitle: "天地宇宙开泰的太极数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "2": {
    symbol: "▲",
    title: "一身孤节",
    subtitle: "混沌未定的分离破灭数",
    genderLuck: "男女皆大凶",
    chartLuck: "大凶",
  },
  "3": {
    symbol: "◎",
    title: "吉祥",
    subtitle: "进取如意的增进繁荣数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "4": {
    symbol: "▲",
    title: "凶变",
    subtitle: "身遭凶变的万事休止数",
    genderLuck: "男女皆大凶",
    chartLuck: "大凶",
  },
  "5": {
    symbol: "◎",
    title: "种竹成林",
    subtitle: "富贵长寿的福禄集合数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "6": {
    symbol: "◎",
    title: "安稳",
    subtitle: "安稳吉庆的吉人天相数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "7": {
    symbol: "○",
    title: "精悍",
    subtitle: "刚毅果断，勇往直前的进取数",
    genderLuck: "男女皆吉",
    chartLuck: "吉",
  },
  "8": {
    symbol: "○",
    title: "坚刚",
    subtitle: "志刚意坚的勤勉发展数",
    genderLuck: "男女皆吉",
    chartLuck: "吉",
  },
  "9": {
    symbol: "△",
    title: "破舟进海",
    subtitle: "吉尽凶始，穷乏困苦数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "10": {
    symbol: "△",
    title: "零暗",
    subtitle: "万事终局充满损耗数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "11": {
    symbol: "◎",
    title: "旱苗逢雨",
    subtitle: "挽回家运的春阳成育数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "12": {
    symbol: "△",
    title: "掘井无泉",
    subtitle: "意志脆弱的家庭寂寞数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "13": {
    symbol: "◎",
    title: "春日牡丹",
    subtitle: "智能超群的成功数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "14": {
    symbol: "△",
    title: "破兆",
    subtitle: "沦落天涯的失意烦闷数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "15": {
    symbol: "◎",
    title: "福寿",
    subtitle: "福寿拱照的立身兴家数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "16": {
    symbol: "◎",
    title: "厚重",
    subtitle: "兴家得助的贵数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "17": {
    symbol: "◎",
    title: "刚强",
    subtitle: "突破万难的刚柔兼备数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "18": {
    symbol: "◎",
    title: "铁镜重磨",
    subtitle: "有志竟成的内外吉数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "19": {
    symbol: "●",
    title: "多难",
    subtitle: "遮云蔽月的辛苦重来数",
    genderLuck: "男女皆半凶",
    chartLuck: "半凶",
  },
  "20": {
    symbol: "△",
    title: "屋下藏金",
    subtitle: "非业破运的空虚数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "21": {
    symbol: "●",
    title: "明月中天",
    subtitle: "明月光照，体质刚健，独立权威数",
    genderLuck: "男吉女半凶",
    chartLuck: "男吉女半凶",
  },
  "22": {
    symbol: "●",
    title: "秋草",
    subtitle: "秋草逢霜的斗争数",
    genderLuck: "男女皆半凶",
    chartLuck: "半凶",
  },
  "23": {
    symbol: "●",
    title: "壮丽",
    subtitle: "旭日东升，发育旺盛数",
    genderLuck: "男吉女凶",
    chartLuck: "男吉女凶",
  },
  "24": {
    symbol: "◎",
    title: "掘藏得金",
    subtitle: "家门余庆的金钱丰盈数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "25": {
    symbol: "○",
    title: "英俊",
    subtitle: "资性英敏的刚毅数",
    genderLuck: "男女皆吉",
    chartLuck: "吉",
  },
  "26": {
    symbol: "△",
    title: "变怪",
    subtitle: "变怪奇异的豪侠数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "27": {
    symbol: "●",
    title: "增长",
    subtitle: "欲望无止境，宜静待时数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "28": {
    symbol: "●",
    title: "阔水浮萍",
    subtitle: "豪气生离的行踪无定数",
    genderLuck: "男半吉女凶",
    chartLuck: "男半吉女凶",
  },
  "29": {
    symbol: "●",
    title: "不平",
    subtitle: "急舟顺展的大立功数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "30": {
    symbol: "●",
    title: "非运",
    subtitle: "绝境逢生的运途分歧数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "31": {
    symbol: "◎",
    title: "春日花开",
    subtitle: "智勇得志，可享清福数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "32": {
    symbol: "◎",
    title: "宝马金鞍",
    subtitle: "侥幸多能的意外惠泽运数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "33": {
    symbol: "●",
    title: "升天",
    subtitle: "家门昌隆，才德开展数",
    genderLuck: "男吉女凶",
    chartLuck: "男吉女凶",
  },
  "34": {
    symbol: "●",
    title: "破家",
    subtitle: "破家亡身的见识浅少数",
    genderLuck: "男半吉女凶",
    chartLuck: "男半吉女凶",
  },
  "35": {
    symbol: "◎",
    title: "高楼望月",
    subtitle: "温和平静的优美发展数",
    genderLuck: "男吉女大吉",
    chartLuck: "男吉女大吉",
  },
  "36": {
    symbol: "●",
    title: "波澜",
    subtitle: "风浪不平静的枉费心力数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "37": {
    symbol: "◎",
    title: "猛虎下山",
    subtitle: "权威显达，发展基业数",
    genderLuck: "男大吉女吉",
    chartLuck: "男大吉女吉",
  },
  "38": {
    symbol: "●",
    title: "磨铁成针",
    subtitle: "意志薄弱的刻意经营数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "39": {
    symbol: "●",
    title: "富贵",
    subtitle: "富贵荣华的变化无穷数",
    genderLuck: "男吉女凶",
    chartLuck: "男吉女凶",
  },
  "40": {
    symbol: "●",
    title: "退安",
    subtitle: "谨慎保安的豪胆迈进数",
    genderLuck: "男女皆半凶",
    chartLuck: "半凶",
  },
  "41": {
    symbol: "◎",
    title: "有德",
    subtitle: "德高望重的事事如意数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "42": {
    symbol: "△",
    title: "寒蝉在柳",
    subtitle: "数十艺不成的穷困至极数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "43": {
    symbol: "●",
    title: "散财",
    subtitle: "须防邪途、灾祸重数",
    genderLuck: "男女皆半凶",
    chartLuck: "半凶",
  },
  "44": {
    symbol: "△",
    title: "烦闷",
    subtitle: "须眉难展的力量有限数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "45": {
    symbol: "◎",
    title: "顺风",
    subtitle: "新生泰和的万事如意数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "46": {
    symbol: "●",
    title: "浪里淘金",
    subtitle: "须防复失的离祖破家数",
    genderLuck: "男女皆半凶",
    chartLuck: "半凶",
  },
  "47": {
    symbol: "◎",
    title: "点石成金",
    subtitle: "开花结果的权威进取数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "48": {
    symbol: "◎",
    title: "古松立鹤",
    subtitle: "德智兼备的出身清贵数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "49": {
    symbol: "●",
    title: "转变",
    subtitle: "吉凶难分的不断辛苦数",
    genderLuck: "男女皆半凶",
    chartLuck: "半凶",
  },
  "50": {
    symbol: "●",
    title: "小舟进海",
    subtitle: "吉凶参半，需防倾覆数",
    genderLuck: "男女皆吉后凶",
    chartLuck: "吉后凶",
  },
  "51": {
    symbol: "●",
    title: "沉浮",
    subtitle: "盛衰交加的竭力经营数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "52": {
    symbol: "◎",
    title: "达眼",
    subtitle: "先见之明，理想实现数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "53": {
    symbol: "●",
    title: "曲卷难星",
    subtitle: "忧愁困苦，内心忧愁数",
    genderLuck: "男女皆半凶",
    chartLuck: "半凶",
  },
  "54": {
    symbol: "△",
    title: "石上栽花",
    subtitle: "多难悲运的难望成功数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "55": {
    symbol: "△",
    title: "善恶",
    subtitle: "外美内恶的和顺不实数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "56": {
    symbol: "△",
    title: "海里行舟",
    subtitle: "初历尽困苦，四周障碍数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "57": {
    symbol: "●",
    title: "日照春松",
    subtitle: "寒雪青松的最大运数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "58": {
    symbol: "●",
    title: "晚行碰月",
    subtitle: "先苦后甜，气宏扬名数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "59": {
    symbol: "△",
    title: "寒蝉悲风",
    subtitle: "须防外患的时运不济数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "60": {
    symbol: "△",
    title: "无谋",
    subtitle: "争名夺利，黑暗无光数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "61": {
    symbol: "○",
    title: "牡丹芙蓉",
    subtitle: "名利双收的修行积德数",
    genderLuck: "男女皆吉",
    chartLuck: "吉",
  },
  "62": {
    symbol: "△",
    title: "衰败",
    subtitle: "基根虚弱的艰困厄数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "63": {
    symbol: "◎",
    title: "舟归平浦",
    subtitle: "富贵荣华的身心安泰数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "64": {
    symbol: "△",
    title: "非命",
    subtitle: "骨肉分离，孤独悲恨数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "65": {
    symbol: "◎",
    title: "大流归海",
    subtitle: "富贵长寿的志在四方数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
  "66": {
    symbol: "△",
    title: "岩头步马",
    subtitle: "内外不和的多祸失福数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "67": {
    symbol: "○",
    title: "通达",
    subtitle: "利路亨通的坚强数",
    genderLuck: "男女皆吉",
    chartLuck: "吉",
  },
  "68": {
    symbol: "○",
    title: "顺风吹帆",
    subtitle: "兴家立业的宽容好运数",
    genderLuck: "男女皆吉",
    chartLuck: "吉",
  },
  "69": {
    symbol: "△",
    title: "非业",
    subtitle: "坐立不安处世多难数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "70": {
    symbol: "△",
    title: "残菊逢霜",
    subtitle: "家庭衰退的晚景凄凉数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "71": {
    symbol: "△",
    title: "石上金花",
    subtitle: "没有实质的磨神耐劳数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "72": {
    symbol: "△",
    title: "劳苦",
    subtitle: "先甜后苦的万难忍受数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "73": {
    symbol: "●",
    title: "无难",
    subtitle: "志高力微的努力奋斗数",
    genderLuck: "男女皆半凶半吉",
    chartLuck: "半凶半吉",
  },
  "74": {
    symbol: "△",
    title: "残菊经霜",
    subtitle: "沉沦逆境的秋叶落寞数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "75": {
    symbol: "●",
    title: "退守",
    subtitle: "守者可安，发迹甚迟数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "76": {
    symbol: "△",
    title: "离散",
    subtitle: "倾覆离散，虽劳无功数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "77": {
    symbol: "●",
    title: "半吉",
    subtitle: "家庭有悦的半凶半吉数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "78": {
    symbol: "●",
    title: "晚苦",
    subtitle: "晚境凄凉的功德光荣数",
    genderLuck: "男女皆半吉",
    chartLuck: "半吉",
  },
  "79": {
    symbol: "△",
    title: "云头望月",
    subtitle: "挽回乏力的身疲力尽数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "80": {
    symbol: "△",
    title: "遁吉",
    subtitle: "凶星入度的消极缩小数",
    genderLuck: "男女皆凶",
    chartLuck: "凶",
  },
  "81": {
    symbol: "◎",
    title: "万物回春",
    subtitle: "万物回春，还原复始的积极盛大数",
    genderLuck: "男女皆大吉",
    chartLuck: "大吉",
  },
} as Record<number, Numerology81Meta>;

export const NUMEROLOGY_81_GENDER_LUCK: Record<number, string> = {
  "1": "男女皆大吉",
  "2": "男女皆大凶",
  "3": "男女皆大吉",
  "4": "男女皆大凶",
  "5": "男女皆大吉",
  "6": "男女皆大吉",
  "7": "男女皆吉",
  "8": "男女皆吉",
  "9": "男女皆凶",
  "10": "男女皆凶",
  "11": "男女皆大吉",
  "12": "男女皆凶",
  "13": "男女皆大吉",
  "14": "男女皆凶",
  "15": "男女皆大吉",
  "16": "男女皆大吉",
  "17": "男女皆大吉",
  "18": "男女皆大吉",
  "19": "男女皆半凶",
  "20": "男女皆凶",
  "21": "男吉女半凶",
  "22": "男女皆半凶",
  "23": "男吉女凶",
  "24": "男女皆大吉",
  "25": "男女皆吉",
  "26": "男女皆凶",
  "27": "男女皆半吉",
  "28": "男半吉女凶",
  "29": "男女皆半吉",
  "30": "男女皆半吉",
  "31": "男女皆大吉",
  "32": "男女皆大吉",
  "33": "男吉女凶",
  "34": "男半吉女凶",
  "35": "男吉女大吉",
  "36": "男女皆半吉",
  "37": "男大吉女吉",
  "38": "男女皆半吉",
  "39": "男吉女凶",
  "40": "男女皆半凶",
  "41": "男女皆大吉",
  "42": "男女皆凶",
  "43": "男女皆半凶",
  "44": "男女皆凶",
  "45": "男女皆大吉",
  "46": "男女皆半凶",
  "47": "男女皆大吉",
  "48": "男女皆大吉",
  "49": "男女皆半凶",
  "50": "男女皆吉后凶",
  "51": "男女皆半吉",
  "52": "男女皆大吉",
  "53": "男女皆半凶",
  "54": "男女皆凶",
  "55": "男女皆凶",
  "56": "男女皆凶",
  "57": "男女皆半吉",
  "58": "男女皆半吉",
  "59": "男女皆凶",
  "60": "男女皆凶",
  "61": "男女皆吉",
  "62": "男女皆凶",
  "63": "男女皆大吉",
  "64": "男女皆凶",
  "65": "男女皆大吉",
  "66": "男女皆凶",
  "67": "男女皆吉",
  "68": "男女皆吉",
  "69": "男女皆凶",
  "70": "男女皆凶",
  "71": "男女皆凶",
  "72": "男女皆凶",
  "73": "男女皆半凶半吉",
  "74": "男女皆凶",
  "75": "男女皆半吉",
  "76": "男女皆凶",
  "77": "男女皆半吉",
  "78": "男女皆半吉",
  "79": "男女皆凶",
  "80": "男女皆凶",
  "81": "男女皆大吉",
} as Record<number, string>;

export const NUMEROLOGY_81_CHART_LUCK: Record<number, string> = {
  "1": "大吉",
  "2": "大凶",
  "3": "大吉",
  "4": "大凶",
  "5": "大吉",
  "6": "大吉",
  "7": "吉",
  "8": "吉",
  "9": "凶",
  "10": "凶",
  "11": "大吉",
  "12": "凶",
  "13": "大吉",
  "14": "凶",
  "15": "大吉",
  "16": "大吉",
  "17": "大吉",
  "18": "大吉",
  "19": "半凶",
  "20": "凶",
  "21": "男吉女半凶",
  "22": "半凶",
  "23": "男吉女凶",
  "24": "大吉",
  "25": "吉",
  "26": "凶",
  "27": "半吉",
  "28": "男半吉女凶",
  "29": "半吉",
  "30": "半吉",
  "31": "大吉",
  "32": "大吉",
  "33": "男吉女凶",
  "34": "男半吉女凶",
  "35": "男吉女大吉",
  "36": "半吉",
  "37": "男大吉女吉",
  "38": "半吉",
  "39": "男吉女凶",
  "40": "半凶",
  "41": "大吉",
  "42": "凶",
  "43": "半凶",
  "44": "凶",
  "45": "大吉",
  "46": "半凶",
  "47": "大吉",
  "48": "大吉",
  "49": "半凶",
  "50": "吉后凶",
  "51": "半吉",
  "52": "大吉",
  "53": "半凶",
  "54": "凶",
  "55": "凶",
  "56": "凶",
  "57": "半吉",
  "58": "半吉",
  "59": "凶",
  "60": "凶",
  "61": "吉",
  "62": "凶",
  "63": "大吉",
  "64": "凶",
  "65": "大吉",
  "66": "凶",
  "67": "吉",
  "68": "吉",
  "69": "凶",
  "70": "凶",
  "71": "凶",
  "72": "凶",
  "73": "半凶半吉",
  "74": "凶",
  "75": "半吉",
  "76": "凶",
  "77": "半吉",
  "78": "半吉",
  "79": "凶",
  "80": "凶",
  "81": "大吉",
} as Record<number, string>;
